/* Settings.ts */

export enum Status {
  DEFAULT = "default",
  DEVELOPMENT = "development",
}
